import { Component, NgZone, OnDestroy, OnInit, inject, ChangeDetectionStrategy } from "@angular/core";
import { ProgressSpinnerMode } from "@angular/material/progress-spinner";
import { Subscription } from "rxjs";
import { LoaderService } from "./loader.service";
import { ThemePalette } from "@angular/material/core";

@Component({
    selector: "app-loader",
    templateUrl: "./loader.component.html",
    styleUrls: ["./loader.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LoaderComponent implements OnInit, OnDestroy {
  loaderService = inject(LoaderService);
  private zone = inject(NgZone);

  color: ThemePalette = "primary";
  mode: ProgressSpinnerMode = "indeterminate";
  value = 50;
  isLoading: boolean;
  subs: Subscription;

  ngOnInit(): void {
    this.subs = this.loaderService.isLoading.subscribe((v) => {
      this.zone.run(() => {
        this.isLoading = v;
      });
    });
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
